export const USE_CASES = [
    ///////////// CALENDAR
    {
        title: 'Schedule appointments',
        body: 'Use pre-built components or the FreeBusy API to schedule meetings.',
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Train AI models on meeting transcripts',
        body: 'Use our Recording object from the Unified Calendar API to get detailed meeting transcripts.',
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Display Calendar Events',
        body: "Use our Unified Calendar API to fetch the user's calendar events.",
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Check Availability',
        body: 'Access free/busy availability across calendar platforms.',
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Insert Scheduling Links',
        body: 'Fetch user scheduling links from calendar providers.',
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Access Meeting Transcripts',
        body: 'Fetch meeting recordings and transcripts from calendar platforms.',
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Schedule Resources',
        body: 'Schedule rooms or shared resources using calendar availability data.',
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Track Time',
        body: 'Generate time entries based on calendar events and meeting data.',
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Webinars',
        body: 'Create, update, and manage webinars — including registrants, panelists, join links, capacity, and recurrence — across supported platforms.',
        category: 'calendar',
        button: { link: 'https://unified.to/calendar', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///// ACCOUNTING
    {
        title: 'Access Financial Data',
        body: 'Pull financial data to support insights and ROI calculations.',
        category: 'accounting',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Automate Invoicing',
        body: 'Sync accounting software with payment gateways for automated invoicing.',
        category: 'accounting',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Expenses',
        body: 'Aggregate and monitor business expenses in real time.',
        category: 'accounting',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Real-time Transactions',
        body: 'Directly enter transactions into accounting systems in real time.',
        category: 'accounting',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Consolidate Entities',
        body: 'Aggregate financial data across multiple accounting systems or business entities.',
        category: 'accounting',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Generate Reports',
        body: 'Pull invoices, bills, expenses, and summaries to generate financial reports programmatically.',
        category: 'accounting',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Financial Data',
        body: 'Stream accounting data into analytics or BI systems alongside other business metrics.',
        category: 'accounting',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Automate Bookkeeping',
        body: 'Categorize transactions, reconcile accounts, and update records using live accounting data.',
        category: 'accounting',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    /////////////

    ///////////// REPOSITORY

    {
        title: 'Access Repositories',
        body: 'Fetch repositories and repository metadata from supported version control platforms.',
        category: 'repo',
        button: { link: 'https://unified.to/repo', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Commits',
        body: 'Access commit history, authorship, and change metadata across repositories.',
        category: 'repo',
        button: { link: 'https://unified.to/repo', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Pull Requests',
        body: 'Read and update pull requests, reviews, comments, and approval status.',
        category: 'repo',
        button: { link: 'https://unified.to/repo', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Trigger Pipelines',
        body: 'Trigger CI/CD pipelines based on repository events such as commits or merges.',
        category: 'repo',
        button: { link: 'https://unified.to/repo', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Builds & Deploys',
        body: 'Access build and deployment status from connected CI/CD systems.',
        category: 'repo',
        button: { link: 'https://unified.to/repo', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Repository Settings',
        body: 'Create repositories, manage permissions, and sync repository configuration across platforms.',
        category: 'repo',
        button: { link: 'https://unified.to/repo', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// ADS
    {
        title: 'Track Campaign Performance',
        body: 'Pull campaign, ad group, and ad performance metrics across platforms.',
        category: 'ads',
        button: { link: 'https://unified.to/ads', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Monitor and Adjust Budgets',
        body: 'Track spend and update campaign budgets in real time.',
        category: 'ads',
        button: { link: 'https://unified.to/ads', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Campaign Lifecycle',
        body: 'Create, update, pause, and terminate campaigns across supported platforms.',
        category: 'ads',
        button: { link: 'https://unified.to/ads', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Creative and Targeting',
        body: 'Modify creatives, targeting parameters, and scheduling from your product.',
        category: 'ads',
        button: { link: 'https://unified.to/ads', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// ANALYTICS
    {
        title: 'Track Website Traffic',
        body: 'Pull page views, sessions, and visitor counts across analytics platforms with a single API.',
        category: 'analytics',
        button: { link: 'https://unified.to/analytics', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Monitor Conversion Events',
        body: 'Track sign-ups, purchases, form submissions, and custom events to measure funnel performance.',
        category: 'analytics',
        button: { link: 'https://unified.to/analytics', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Build Unified Dashboards',
        body: 'Aggregate reports and metrics from Google Analytics, Plausible, and other providers into one view.',
        category: 'analytics',
        button: { link: 'https://unified.to/analytics', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Attribute Marketing Campaigns',
        body: 'Pull UTM parameters, sources, and mediums to measure acquisition and campaign ROI.',
        category: 'analytics',
        button: { link: 'https://unified.to/analytics', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Analyze User Sessions',
        body: 'Access session duration, bounce rate, landing pages, and engagement data across properties.',
        category: 'analytics',
        button: { link: 'https://unified.to/analytics', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Visitor Profiles',
        body: 'Identify and enrich returning visitors by syncing visitor records across analytics tools.',
        category: 'analytics',
        button: { link: 'https://unified.to/analytics', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// ASSESSMENT
    {
        title: 'Embedded Native ATS Integrations',
        body: 'List assessment packages directly inside supported ATS platforms and receive recruiter-initiated orders.',
        category: 'assessment',
        button: { link: 'https://unified.to/assessment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Trigger Assessments from Application Status',
        body: 'Automatically order assessments when candidates reach specific stages inside an ATS.',
        category: 'assessment',
        button: { link: 'https://unified.to/assessment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Submit and Sync Results',
        body: 'Update assessment orders with scores, attributes, and result URLs so results appear directly inside the ATS.',
        category: 'assessment',
        button: { link: 'https://unified.to/assessment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Support Background and Verification Flows',
        body: 'Handle verification-style calls initiated by ATS or HRIS platforms through unified data models.',
        category: 'assessment',
        button: { link: 'https://unified.to/assessment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// ATS

    {
        title: 'Source Candidates',
        body: 'Enable users to source candidates and send updates back to their ATS.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Assess Candidates',
        body: "Trigger assessments and send updates back to your users' ATS.",
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Promote Jobs',
        body: 'Enable users to post to multiple job boards and send updates to their ATS.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Applications',
        body: 'Enable real-time updates and communication on candidate statuses from any ATS.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Parse Resumes',
        body: 'Automatically extract and store key resume data, centralizing candidate information.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Track Hiring Metrics',
        body: 'Pull hiring and pipeline metrics across ATS platforms.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Schedule Interviews',
        body: 'Access interview and availability data to coordinate and track interviews.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Run Background Checks',
        body: 'Trigger background checks and sync verification results to candidate records.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Offers',
        body: 'Create, track, and update offer status within the ATS.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Job Postings',
        body: 'Sync job postings and updates across ATS platforms and connected channels.',
        category: 'ats',
        button: { link: 'https://unified.to/ats', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    /////////////

    ///////////// AUTH
    {
        title: 'Single Sign-on',
        body: 'Enable secure SSO across multiple applications for improved user experience.',
        category: 'auth',
        button: { link: 'https://unified.to/auth', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Multi-factor Authentication',
        body: 'Implement MFA to enhance security for sensitive operations.',
        category: 'auth',
        button: { link: 'https://unified.to/auth', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Management',
        body: 'Manage user roles and permissions dynamically based on real-time data.',
        category: 'auth',
        button: { link: 'https://unified.to/auth', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    ///////////// CALL CENTER
    {
        title: 'Analyze Calls',
        body: 'Analyze call details from multiple systems to enhance customer interactions.',
        category: 'uc',
        button: { link: 'https://unified.to/uc', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Customers',
        body: 'Integrate call center systems for real-time access to customer data during calls.',
        category: 'uc',
        button: { link: 'https://unified.to/uc', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Call Activity',
        body: 'Pull call volume, duration, wait times, and agent activity across platforms.',
        category: 'uc',
        button: { link: 'https://unified.to/uc', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Call Records',
        body: 'Sync call records and events across call center systems and downstream tools.',
        category: 'uc',
        button: { link: 'https://unified.to/uc', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Call Recordings',
        body: 'Fetch call recordings and transcripts from call center platforms.',
        category: 'uc',
        button: { link: 'https://unified.to/uc', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Route Calls',
        body: 'Route calls and manage queues using call center system data.',
        category: 'uc',
        button: { link: 'https://unified.to/uc', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Link Calls to Customers',
        body: 'Associate calls with customer records in connected systems.',
        category: 'uc',
        button: { link: 'https://unified.to/uc', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// CRM
    {
        title: 'Generate Leads',
        body: 'Automate capturing leads and keep CRM information up-to-date.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Generate Insights',
        body: 'Pull CRM data to generate insights about customer behavior and preferences.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Score Leads',
        body: 'Analyze CRM data to automatically score and prioritize leads.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Enrich CRMs',
        body: 'Enhance CRM records with additional contact and company information to boost sales intelligence.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Customers',
        body: 'Sync contacts, companies, deals, and events across systems for a unified customer view.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Deals',
        body: 'Sync deal and pipeline data across CRM systems and tools.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Pipeline',
        body: 'Track deal stages, values, and pipeline movement in real time.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Unify Customer Records',
        body: 'Aggregate contact, company, and deal data across CRM systems.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Marketing Activity',
        body: 'Sync marketing engagement data with CRM contacts and leads.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Route Leads',
        body: 'Assign leads to owners based on CRM rules or attributes.',
        category: 'crm',
        button: { link: 'https://unified.to/crm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// SHIPPING
    {
        category: 'shipping',
        title: 'Calculate Shipping Rates',
        body: 'Calculate shipping rates for a shipment based on the from and to addresses.',
        button: { link: 'https://unified.to/shipping', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        category: 'shipping',
        title: 'Create a Shipping Label',
        body: 'Create a shipping label for a shipment.',
        button: { link: 'https://unified.to/shipping', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        category: 'shipping',
        title: 'Track a Shipment',
        body: 'Track a shipment based on the tracking number.',
        button: { link: 'https://unified.to/shipping', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        category: 'shipping',
        title: 'Create a shipment',
        body: 'Create a shipment for a shipment based on the from and to addresses.',
        button: { link: 'https://unified.to/shipping', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// E-COMMERCE

    {
        title: 'Marketplace Setup',
        body: 'Enable retailers to easily integrate and manage online marketplaces with the top e-com platforms.',
        category: 'commerce',
        button: { link: 'https://unified.to/commerce', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Multi-vendor Orders',
        body: 'Streamline orders from multiple sellers into a single transaction, allowing customers to pay once for items from different vendors.',
        category: 'commerce',
        button: { link: 'https://unified.to/commerce', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Products',
        body: 'Import product data from different e-com stores to create a unified catalog across multiple platforms.',
        category: 'commerce',
        button: { link: 'https://unified.to/commerce', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Inventory',
        body: 'Keep inventory levels synchronized across sellers, platforms, and sales channels.',
        category: 'commerce',
        button: { link: 'https://unified.to/commerce', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Reviews',
        body: 'Fetch product reviews and ratings from connected commerce platforms.',
        category: 'commerce',
        button: { link: 'https://unified.to/commerce', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Commerce Data',
        body: 'Stream product, inventory, and order data into analytics or downstream systems.',
        category: 'commerce',
        button: { link: 'https://unified.to/commerce', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// ENRICHMENT
    {
        title: 'Enrich Contacts',
        body: 'Enhance contact records with additional data like social media profiles, emails, and phone numbers.',
        category: 'enrich',
        button: { link: 'https://unified.to/enrich', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Qualify Leads',
        body: 'Enhance lead data with enrichment APIs to identify high-potential customers.',
        category: 'enrich',
        button: { link: 'https://unified.to/enrich', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Generate Insights',
        body: 'Pull enriched data to provide sales teams with deeper customer insights.',
        category: 'enrich',
        button: { link: 'https://unified.to/enrich', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Company Enrichment',
        body: 'Enhance company records with revenue, employee count, and social media presence.',
        category: 'enrich',
        button: { link: 'https://unified.to/enrich', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// STORAGE
    {
        title: 'Sync Files',
        body: 'Sync files across cloud storage platforms for unified access.',
        category: 'storage',
        button: { link: 'https://unified.to/storage', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Automate Backups',
        body: 'Automate backups across multiple file storage services for redundancy.',
        category: 'storage',
        button: { link: 'https://unified.to/storage', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Generate Insights',
        body: "Train your AI models on your customers' files and documents.",
        category: 'storage',
        button: { link: 'https://unified.to/storage', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Search Files',
        body: 'Search and retrieve files across multiple cloud storage platforms.',
        category: 'storage',
        button: { link: 'https://unified.to/storage', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Aggregate Content',
        body: 'Aggregate files and metadata from multiple storage accounts into a unified view.',
        category: 'storage',
        button: { link: 'https://unified.to/storage', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Permissions',
        body: 'Read and manage file permissions and sharing settings across platforms.',
        category: 'storage',
        button: { link: 'https://unified.to/storage', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Stream File Data',
        body: 'Stream file contents and metadata into downstream systems or applications.',
        category: 'storage',
        button: { link: 'https://unified.to/storage', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// FORMS
    {
        title: 'Collect Submissions',
        body: 'Fetch form submissions from supported form platforms in real time.',
        category: 'forms',
        button: { link: 'https://unified.to/forms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Form Data',
        body: 'Sync form responses into CRMs, databases, or downstream systems.',
        category: 'forms',
        button: { link: 'https://unified.to/forms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Trigger Workflows',
        body: 'Trigger application logic or downstream actions when form submissions occur.',
        category: 'forms',
        button: { link: 'https://unified.to/forms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Aggregate Responses',
        body: 'Aggregate responses across multiple form platforms into a unified dataset.',
        category: 'forms',
        button: { link: 'https://unified.to/forms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Store Form Data',
        body: 'Store and manage form submission data in a centralized system.',
        category: 'forms',
        button: { link: 'https://unified.to/forms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Form Metadata',
        body: 'Fetch form structures, fields, and configuration details from form platforms.',
        category: 'forms',
        button: { link: 'https://unified.to/forms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// GENAI
    {
        title: 'Call Models',
        body: 'Send prompts to supported AI models across multiple providers.',
        category: 'genai',
        button: { link: 'https://unified.to/genai', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Route Requests',
        body: 'Route AI requests between providers based on availability or configuration.',
        category: 'genai',
        button: { link: 'https://unified.to/genai', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Compare Outputs',
        body: 'Run the same prompt across multiple models and compare responses.',
        category: 'genai',
        button: { link: 'https://unified.to/genai', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Generate Embeddings',
        body: 'Generate text embeddings using supported AI providers.',
        category: 'genai',
        button: { link: 'https://unified.to/genai', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// HRIS
    {
        title: 'Onboarding',
        body: 'Onboard employees and update profiles when roles change.',
        category: 'hris',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Offboarding',
        body: 'Seamlessly integrate employee data to automate the offboarding processess.',
        category: 'hris',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track PTO',
        body: 'Pull time off (PTO) information to monitor and manage employee leave balances and schedules in real-time.',
        category: 'hris',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Employee Directory',
        body: 'Sync employee profiles, departments, and reporting structures from HR systems.',
        category: 'hris',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Provision Access',
        body: 'Provision, update, or revoke user access based on employee status or role changes.',
        category: 'hris',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Benefits Data',
        body: 'Access employee benefits, eligibility, and enrollment information from HR platforms.',
        category: 'hris',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Time & Attendance',
        body: 'Access schedules, attendance, and work hours from HR systems.',
        category: 'hris',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Payroll Data',
        body: 'Sync employee and compensation data with payroll systems.',
        category: 'hris',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// LMS
    {
        title: 'Manage Enrolments',
        body: 'Enrol student into courses, classes and content',
        category: 'lms',
        button: { link: 'https://unified.to/lms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Course Content',
        body: 'Retrieve course materials — including modules, media, and content assets — from supported LMS platforms.',
        category: 'lms',
        button: { link: 'https://unified.to/lms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Activity and Completion',
        body: 'Track learner progress, completion status, duration, and timestamps in real time.',
        category: 'lms',
        button: { link: 'https://unified.to/lms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Replicate and Distribute Courses',
        body: 'Sync courses and content between LMS platforms or surface learning materials inside your own product.',
        category: 'lms',
        button: { link: 'https://unified.to/lms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Embed Learning Materials in Your Product',
        body: 'Pull structured LMS content and display training materials directly inside your application.',
        category: 'lms',
        button: { link: 'https://unified.to/lms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// KMS
    {
        title: 'Access Knowledge Content',
        body: 'Fetch knowledge base articles and documentation from supported platforms.',
        category: 'kms',
        button: { link: 'https://unified.to/kms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Search Knowledge',
        body: 'Search across multiple knowledge bases to find relevant documentation.',
        category: 'kms',
        button: { link: 'https://unified.to/kms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Aggregate Knowledge',
        body: 'Aggregate content from multiple knowledge platforms into a unified view.',
        category: 'kms',
        button: { link: 'https://unified.to/kms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Knowledge Content',
        body: 'Sync documentation across knowledge management platforms.',
        category: 'kms',
        button: { link: 'https://unified.to/kms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Migrate Content',
        body: 'Migrate articles and documentation between knowledge platforms.',
        category: 'kms',
        button: { link: 'https://unified.to/kms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Content Metadata',
        body: 'Fetch metadata such as authorship, timestamps, and update history.',
        category: 'kms',
        button: { link: 'https://unified.to/kms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Summarize Documents',
        body: 'Generate concise summaries of project documents, meeting notes, and employee handbooks.',
        category: 'kms',
        button: { link: 'https://unified.to/kms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'AI Assistant',
        body: 'Create an AI assistant that leverages help center content to provide instant, accurate responses to customers.',
        category: 'kms',
        button: { link: 'https://unified.to/kms', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// MARTTECH
    {
        title: 'Track Campaign Data',
        body: 'Pull campaign performance and engagement data from marketing platforms.',
        category: 'martech',
        button: { link: 'https://unified.to/martech', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Leads',
        body: 'Sync leads and contacts between marketing platforms and connected systems.',
        category: 'martech',
        button: { link: 'https://unified.to/martech', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Marketing Lists',
        body: 'Sync subscriber lists, manage subscriptions, and handle unsubscribes across platforms.',
        category: 'martech',
        button: { link: 'https://unified.to/martech', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Segment Audiences',
        body: 'Create and update audience segments using marketing platform data.',
        category: 'martech',
        button: { link: 'https://unified.to/martech', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Marketing Data',
        body: 'Stream marketing data into analytics tools, CRMs, or downstream systems.',
        category: 'martech',
        button: { link: 'https://unified.to/martech', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// MESSAGING
    {
        title: 'Summarize Conversations',
        body: 'Generate concise summaries of internal discussions from email and chat.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Ticket Creation',
        body: 'Use AI to detect bugs and issues in informal communications and automatically create tickets.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Analyze Sentiment',
        body: 'Analyze customer messages to assess sentiment and detect early signs of churn.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Read Messages',
        body: 'Fetch messages and conversation threads from supported messaging platforms.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Send Messages',
        body: 'Send messages to channels, threads, or users across messaging platforms.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Conversations',
        body: 'Sync messages and threads across multiple messaging platforms.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Monitor Activity',
        body: 'Track message volume, activity, and event signals across platforms.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Trigger Workflows',
        body: 'Trigger application logic based on messaging events or actions.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Archive Messages',
        body: 'Capture and store messages for long-term access or compliance needs.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Message Metadata',
        body: 'Fetch channel, user, timestamp, and message context metadata.',
        category: 'messaging',
        button: { link: 'https://unified.to/messaging', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// PAYMENT
    {
        title: 'Payment Links',
        body: 'Generate and send payment links with invoices, making it easy for customers to pay online.',
        category: 'payment',
        button: { link: 'https://unified.to/payment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    {
        title: 'Track Transactions',
        body: 'Access payment, refund, and payout transaction data in real time.',
        category: 'payment',
        button: { link: 'https://unified.to/payment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Subscriptions',
        body: 'Create, update, and track subscription status and recurring billing data.',
        category: 'payment',
        button: { link: 'https://unified.to/payment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Reconcile Payments & Refunds',
        body: 'Match payments, refunds, and payouts with invoices or external systems.',
        category: 'payment',
        button: { link: 'https://unified.to/payment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Payment Data',
        body: 'Stream payment and transaction data into accounting or downstream systems.',
        category: 'payment',
        button: { link: 'https://unified.to/payment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    /////////////

    ///////////// TASK
    {
        title: 'Customize Notifications',
        body: 'Get alerts on tasks and deadlines that matter most.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Prioritize Tasks',
        body: 'Automatically prioritize tasks by analyzing due dates, priority levels, and workload.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage Projects',
        body: 'Use historical task data to predict project completion dates and identify bottlenecks.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Personalize Insights',
        body: "Deliver AI-driven insights based on users' task management patterns to maximize work hours.",
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Tasks',
        body: 'Fetch tasks, statuses, due dates, and task metadata from task management platforms.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Create & Update Tasks',
        body: 'Create tasks and update task fields such as status, priority, and assignee.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Tasks',
        body: 'Sync tasks and updates across multiple task management platforms.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Projects',
        body: 'Fetch project structures, boards, lists, and associated tasks.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Task Activity',
        body: 'Track task changes, assignments, and status updates in real time.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Trigger Task Workflows',
        body: 'Trigger application logic based on task events such as creation, updates, or completion.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Assignments & Workloads',
        body: 'Access task assignments and workload data for users or teams.',
        category: 'task',
        button: { link: 'https://unified.to/task', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// TICKETING
    {
        title: 'Resolve Issues',
        body: 'Train AI models on historical ticketing data to predict potential customer issues and reduce resolution time.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Analyze Sentiment',
        body: 'Automatically categorize customer feedback as positive, negative, or neutral using AI-powered sentiment analysis.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Employee Self-Service',
        body: 'Implement a unified ticketing system for HR inquiries, enabling employees to submit and track requests.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Tickets',
        body: 'Fetch tickets, statuses, priorities, and metadata from ticketing platforms.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Create & Update Tickets',
        body: 'Create tickets and update fields such as status, priority, and category.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Ticket Activity',
        body: 'Track ticket changes, comments, and status updates in real time.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Route & Assign Tickets',
        body: 'Assign tickets to agents or queues based on ticket attributes.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Customer History',
        body: 'Access historical tickets, conversations, and notes associated with a customer.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Tickets',
        body: 'Sync tickets and updates across multiple ticketing platforms.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Trigger Ticket Workflows',
        body: 'Trigger application logic based on ticket events such as creation, updates, or resolution.',
        category: 'ticketing',
        button: { link: 'https://unified.to/ticketing', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// VERIFICATION
    {
        title: 'Request Verifications',
        body: 'Initiate background checks, identity verification, or employment verification with supported providers.',
        category: 'verification',
        button: { link: 'https://unified.to/verification', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Verification Status',
        body: 'Track progress and completion through webhooks on supported integrations, or by retrieving the request.',
        category: 'verification',
        button: { link: 'https://unified.to/verification', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Verification Results',
        body: 'Retrieve verification outcomes and supporting details from verification providers.',
        category: 'verification',
        button: { link: 'https://unified.to/verification', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Connect checks to hiring and onboarding',
        body: 'Order a check when a candidate reaches a stage, then update the ATS or HR record with the result.',
        category: 'verification',
        button: { link: 'https://unified.to/verification', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Support Multiple Providers',
        body: 'Connect to multiple verification providers through a single integration layer.',
        category: 'verification',
        button: { link: 'https://unified.to/verification', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Trigger Verification Events',
        body: 'Trigger application logic when verification events occur, such as completion or failure.',
        category: 'verification',
        button: { link: 'https://unified.to/verification', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// SCIM
    {
        title: 'Provision Users',
        body: 'Create and update users via SCIM across identity providers.',
        category: 'scim',
        button: { link: 'https://unified.to/scim', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Deprovision Users',
        body: 'Deactivate or remove users via SCIM when access should be revoked.',
        category: 'scim',
        button: { link: 'https://unified.to/scim', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Groups',
        body: 'Sync groups and memberships to manage access consistently.',
        category: 'scim',
        button: { link: 'https://unified.to/scim', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Update Profiles',
        body: 'Sync user attributes (name, email, role, department) via SCIM updates.',
        category: 'scim',
        button: { link: 'https://unified.to/scim', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// CLUBS
    {
        title: 'Read Clubs',
        body: 'Read clubs and members with one API and unified data models.',
        category: 'clubs',
        button: { link: 'https://unified.to/clubs', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Write sports club member activity',
        body: 'Write sports club member activity with one API and unified data models.',
        category: 'clubs',
        button: { link: 'https://unified.to/clubs', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Read Segments',
        body: 'Read segments and profiles with one API and unified data models.',
        category: 'cdp',
        button: { link: 'https://unified.to/cdp', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Write Segment Events',
        body: 'Write segment events with one API and unified data models.',
        category: 'cdp',
        button: { link: 'https://unified.to/cdp', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Read Profiles',
        body: 'Read profiles with one API and unified data models.',
        category: 'cdp',
        button: { link: 'https://unified.to/cdp', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },

    ///////////// PERFORMANCE
    {
        title: 'Set Performance Goals',
        body: 'Create and track employee goals, milestones, and progress across performance platforms.',
        category: 'performance',
        button: { link: 'https://unified.to/performance', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Collect Employee Feedback',
        body: 'Create and sync employee feedback across performance management systems.',
        category: 'performance',
        button: { link: 'https://unified.to/performance', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Access Performance Reviews',
        body: 'Pull performance reviews, ratings, and reviewer comments from HR platforms.',
        category: 'performance',
        button: { link: 'https://unified.to/performance', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// ERP
    {
        title: 'Sync Employee Directory',
        body: 'Sync employee profiles, departments, and reporting structures from HR systems into ERP workflows.',
        category: 'erp',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Invoices & GL',
        body: 'Pull invoices, bills, and general ledger data from accounting systems to keep ERP financials current.',
        category: 'erp',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Catalog, Orders & Inventory',
        body: 'Stream product, order, and inventory data from commerce platforms into ERP operations.',
        category: 'erp',
        button: { link: 'https://unified.to/commerce', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track Shipments',
        body: 'Create labels and track shipments so ERP fulfillment stays in sync with carriers.',
        category: 'erp',
        button: { link: 'https://unified.to/shipping', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// POS
    {
        title: 'Sync Store Staff',
        body: 'Sync employee profiles for in-store staff from HR systems into POS applications.',
        category: 'pos',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Clock-in & Attendance',
        body: 'Access schedules, attendance, and clock-in/out data from HR systems at the point of sale.',
        category: 'pos',
        button: { link: 'https://unified.to/hris', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync Sales Orders',
        body: 'Pull sales orders from accounting systems so POS and back-office records stay aligned.',
        category: 'pos',
        button: { link: 'https://unified.to/accounting', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Take & Reconcile Payments',
        body: 'Access payment, refund, and payout data in real time to reconcile POS transactions.',
        category: 'pos',
        button: { link: 'https://unified.to/payment', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// SOCIAL
    {
        title: 'Read Posts',
        body: 'Read posts and comments with one API and unified data models.',
        category: 'social',
        button: { link: 'https://unified.to/social', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Write Posts',
        body: 'Write posts and comments with one API and unified data models.',
        category: 'social',
        button: { link: 'https://unified.to/social', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Get post metrics',
        body: 'Get post metrics with one API and unified data models.',
        category: 'social',
        button: { link: 'https://unified.to/social', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// LEGAL
    {
        title: 'Create matters from intake',
        body: "Create matters in the firm's practice management system as soon as a new client signs up.",
        category: 'legal',
        button: { link: 'https://unified.to/legal', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Capture billable time',
        body: 'Log billable time and expenses against the right matter with one API and unified data models.',
        category: 'legal',
        button: { link: 'https://unified.to/legal', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Report on firm performance',
        body: 'Analyze matters, time entries, and expenses by practice area and attorney.',
        category: 'legal',
        button: { link: 'https://unified.to/legal', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Power AI legal assistants',
        body: 'Give AI agents real-time access to matters, parties, and billing data.',
        category: 'legal',
        button: { link: 'https://unified.to/legal', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// COMPUTE
    {
        title: 'Compare GPU prices',
        body: 'Compare GPU types, prices, and availability across GPU clouds and regions.',
        category: 'compute',
        button: { link: 'https://unified.to/compute', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Run AI agent sandboxes',
        body: 'Create, pause, resume, and terminate sandboxes for AI agents with one API and unified data models.',
        category: 'compute',
        button: { link: 'https://unified.to/compute', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Launch GPU instances',
        body: "Launch and manage GPU instances on your customer's own cloud account for training and inference.",
        category: 'compute',
        button: { link: 'https://unified.to/compute', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Manage app deployments',
        body: 'Track services, deployments, domains, and environment variables across hosting platforms.',
        category: 'compute',
        button: { link: 'https://unified.to/compute', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// HEALTHCARE
    {
        title: 'Book patient appointments',
        body: 'Show open slots and book, reschedule, or cancel appointments directly in the practice EHR.',
        category: 'healthcare',
        button: { link: 'https://unified.to/healthcare', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Build patient-facing health apps',
        body: 'Display conditions, allergies, medications, lab results, and immunizations from any connected EHR.',
        category: 'healthcare',
        button: { link: 'https://unified.to/healthcare', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Power AI clinical assistants',
        body: 'Give AI agents real-time access to encounters, observations, and medication lists.',
        category: 'healthcare',
        button: { link: 'https://unified.to/healthcare', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Sync remote monitoring readings',
        body: 'Write vital signs and device readings back to the patient record as observations.',
        category: 'healthcare',
        button: { link: 'https://unified.to/healthcare', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////

    ///////////// PROPERTY
    {
        title: 'Sync reservations',
        body: 'Pull reservations, guests, and payment balances from every property management system with one API and unified data models.',
        category: 'property',
        button: { link: 'https://unified.to/property', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Automate guest messaging',
        body: 'Read guest conversations and send check-in instructions tied to the right reservation and listing.',
        category: 'property',
        button: { link: 'https://unified.to/property', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Power dynamic pricing',
        body: 'Read nightly availability and prices across listings and room types to recommend rates.',
        category: 'property',
        button: { link: 'https://unified.to/property', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Analyze guest reviews',
        body: 'Collect reviews and category ratings across listings and booking channels.',
        category: 'property',
        button: { link: 'https://unified.to/property', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    ///////////// PLM
    {
        title: 'Sync the parts library',
        body: 'Pull parts, revisions, and lifecycle states from every PLM system into your ERP, MES, or procurement tool with one API and unified data models.',
        category: 'plm',
        button: { link: 'https://unified.to/plm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Read bills of materials',
        body: 'Walk assembly BOMs with quantities and reference designators to cost products, plan builds, and check supply.',
        category: 'plm',
        button: { link: 'https://unified.to/plm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Track engineering changes',
        body: 'Follow change orders and their affected parts from review to release, and react when a revision goes effective.',
        category: 'plm',
        button: { link: 'https://unified.to/plm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    {
        title: 'Ground AI agents in product data',
        body: 'Give agents live part, BOM, and change data so they can answer questions about parts, revisions, and pending changes.',
        category: 'plm',
        button: { link: 'https://unified.to/plm', title: 'Learn More', icon: 'ic:round-keyboard-arrow-right' },
    },
    /////////////
];
